import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	contentWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.tiny,
		justifyContent: 'center',
	},
	titleWrapper: {
		display: 'flex',
		gap: theme.spacing.xxsmall,
		alignItems: 'center',
	},
	childrenWrapper: {
		p: { ':first-of-type': { color: theme.palette.neutral[50] } },
	},
}));
